import React from 'react';
import Select from 'react-select';
import FontSelectOption from './font-select-option';

const fonts = ['Abel', 'Abhaya Libre', 'Amatic SC', 'Cinzel', 'EB Garamond', 'Josefin Sans', 'Karma', 'Montserrat', 'Nunito', 'Ovo', 'Questrial', 'Rasa', 'Suranna', 'Voltaire', 'Italianno', 'Balthazar', 'Niconne'].map(font => ({ label: font, value: font }));

class FontPicker extends React.Component {
  render() {

    const { value, onChange } = this.props;

    return (
      <div style={{fontFamily: `'${value}'`, marginTop: 4}}>
        <Select
          onChange={({ value }) => onChange(value)}
          optionComponent={FontSelectOption}
          options={fonts}
          clearable={false}
          value={{ label: value, value }}
        />
      </div>
    )
  }
}
export default FontPicker;


// WEBPACK FOOTER //
// ./src/components/common/font-picker.js